import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {reduce} from 'lodash';

import {Store} from 'src/types/store';
import {classYears} from 'shared/portfolio/utils';
import {CURRENT_SCHOOL_YEAR} from 'shared/utils';

import SchoolYear from './school-year';

const CurrentSchoolYears = () => {
  const graduationYear = useSelector((state: Store) => state.student.highSchoolInfo.graduationYear);
  const courses = useSelector((state: Store) => state.bulkEntryCourses);
  const fourSchoolYears = useMemo(() => classYears(graduationYear), [graduationYear]);
  const activeSchoolYears = Object.keys(fourSchoolYears).filter(
    (year) => parseInt(year.split('-')[1]) <= CURRENT_SCHOOL_YEAR
  );

  const coursesByYear = useMemo(
    () =>
      reduce(
        courses,
        (result, course) => {
          if (Object.keys(fourSchoolYears).includes(course.schoolYear)) {
            if (result[course.schoolYear]) {
              result[course.schoolYear].push(course);
            } else {
              result[course.schoolYear] = [course];
            }
          }

          return result;
        },
        {}
      ),
    [courses, fourSchoolYears]
  );

  return activeSchoolYears.map((year) => (
    <SchoolYear
      key={`bulk-entry-course-${year}`}
      year={year}
      coursesForYear={coursesByYear[year] || []}
    />
  ));
};

export default CurrentSchoolYears;
